import { render } from "./PokerRoom.vue?vue&type=template&id=b4edfd2a&scoped=true"
import script from "./PokerRoom.vue?vue&type=script&lang=js"
export * from "./PokerRoom.vue?vue&type=script&lang=js"

import "./PokerRoom.vue?vue&type=style&index=0&id=b4edfd2a&scoped=true&lang=css"

import exportComponent from "/Users/shoheiyamamoto/work/git/team-poker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4edfd2a"]])

export default __exports__